import { defineAsyncComponent } from 'vue'
export default {
  custom: defineAsyncComponent(() => import("/tmp/tmps5w5t0mf/layouts/custom.vue").then(m => m.default || m))
}